import React from 'react';
// Styles
import styles from './style/drawer.module.css';

interface DrawerProps {
  active?:boolean,
  children:React.ReactNode,
  closeHandler: Function,
}

function Drawer({ active, children, closeHandler }:DrawerProps) {
  return (
    <div className={`${styles.container} ${active ? styles.container_active : ''}`}>
      <div className={styles.main}>
        { children }
      </div>
      <div
        aria-label="overlay"
        className={styles.overlay}
        onClick={() => closeHandler()}
        onKeyDown={() => closeHandler()}
        role="button"
        tabIndex={0}
      />
    </div>
  );
}

Drawer.defaultProps = {
  active: false,
}
export default Drawer;
